var _ellipse, _ellipse2, _ellipse3, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 62,
    viewBox: "0 0 80 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.9091,
    cy: 21.8823,
    rx: 10.9091,
    ry: 10.9412,
    fill: "#A6B8C5"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 69.0893,
    cy: 21.8823,
    rx: 10.9091,
    ry: 10.9412,
    fill: "#A6B8C5"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.001,
    cy: 14.5882,
    rx: 14.5455,
    ry: 14.5882,
    fill: "#A6B8C5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2563 61.9999H9.11765C4.08211 61.9999 0 57.9178 0 52.8822C0 47.8467 4.08211 43.7646 9.11765 43.7646H15.7728C17.8215 39.4521 22.2171 36.4706 27.3091 36.4706H53.5979C58.6898 36.4706 63.0854 39.4521 65.1341 43.7646H70.8824C75.9179 43.7646 80 47.8467 80 52.8822C80 57.9178 75.9179 61.9999 70.8824 61.9999H53.6506C53.633 62 53.6154 62 53.5978 62H27.3091C27.2915 62 27.2739 62 27.2563 61.9999Z",
    fill: "#003359"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.2bbc2e4fa6a9ea8aa1d1a6847fcf2c81.svg";
export { ForwardRef as ReactComponent };